import { SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { openInNewTab } from '@/helpers';
import { enUpsellType, IShowcaseBannerUpsell, IUpsell, IUTM } from '@/interfaces/upsell';

import { useCheckout } from './useCheckout';

export const useUpsell = (upsell: IUpsell | IShowcaseBannerUpsell, utm: IUTM) => {
  const openCheckout = useCheckout(upsell, utm);
  const navigate = useNavigate();

  const openInternalUrl = () => {
    navigate(`/curso/${upsell.external_url}`);
  };

  const openExternalUrl = () => {
    const searchParams = [
      'utm_source=NUTROR',
      'utm_campaign=DOMINIOEXTERNO',
      `utm_content=${upsell.id}`,
      'TRK1=NUTROR',
      'TRK2=DOMINIOEXTERNO',
      `utm_medium=${utm.utm_medium}`,
      `TRK3=${upsell.id}`
    ];

    searchParams.forEach(param => {
      upsell['external_url'] = upsell?.external_url?.replace(param, '');
    });

    upsell['external_url'] = upsell?.external_url?.replace(/'&'/g, '');

    openInNewTab(upsell?.external_url);
  };

  return (event: SyntheticEvent) => {
    const mapper: Record<number, (event: SyntheticEvent) => void> = {
      [enUpsellType.checkoutSun]: openCheckout,
      [enUpsellType.nutror]: openInternalUrl,
      [enUpsellType.externalUrl]: openExternalUrl
    };
    return mapper[upsell.show_type](event);
  };
};
